import $ from 'jquery';
import ResizeObserver from 'resize-observer-polyfill';
import { ISLARGEDESKTOP } from '../constants';

$('[data-sticky]').each((index, element) => {
    const bottomPaddingOffset = ISLARGEDESKTOP ? 88 : 56;

    const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
            $(element).parent().css('height', entry.contentRect.height - bottomPaddingOffset + 'px');
        }
    });

    const stickyWrapper = $($(element).data('sticky'));

    $(element).wrap(`<div class="sticky-wrapper"><div class="sticky-container" style="height: ${stickyWrapper.height() - bottomPaddingOffset}px;"></div></div>`);

    resizeObserver.observe(stickyWrapper[0]);
});
